/**
 * Sticky ATC bar — désactive le bouton "Ajouter" tant que les dates de location
 * IzyRent ne sont pas sélectionnées.
 *
 * Why: l'app IzyRent désactive bien le bouton ATC principal de la fiche produit,
 * mais pas le sticky ATC en bas de page (qui est un bouton séparé référençant
 * le form via l'attribut `form="..."`). Sans ce guard, un client peut cliquer
 * le sticky → IzyRent intercepte, scroll up, affiche son erreur "date requise",
 * mais finit quand même par ajouter le produit au panier au prix /jour.
 *
 * Source de vérité : l'élément #izyrent gagne la classe `selectedDates` quand
 * une plage de dates est validée.
 */
(function () {
  'use strict';

  function getStickyButtons() {
    return document.querySelectorAll('sticky-atc-bar-minimalist button[name="add"], sticky-atc-bar button[name="add"]');
  }

  function setDisabled(btn, disabled) {
    if (disabled) {
      btn.setAttribute('disabled', 'disabled');
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
    } else {
      btn.removeAttribute('disabled');
      btn.disabled = false;
      btn.removeAttribute('aria-disabled');
    }
  }

  function sync() {
    var izyrentEl = document.getElementById('izyrent');
    var btns = getStickyButtons();
    if (!btns.length) return;

    if (!izyrentEl) {
      // Pas de IzyRent sur cette page → produit non-location, ne pas toucher
      return;
    }

    var hasDates = izyrentEl.classList.contains('selectedDates');
    btns.forEach(function (btn) {
      setDisabled(btn, !hasDates);
    });
  }

  function init() {
    var izyrentEl = document.getElementById('izyrent');
    if (!izyrentEl) return;

    sync();

    // Observe les changements de classe sur #izyrent (selectedDates ajoutée/retirée)
    new MutationObserver(sync).observe(izyrentEl, {
      attributes: true,
      attributeFilter: ['class']
    });

    // Aussi écouter les events custom IzyRent (au cas où la classe change pas)
    document.addEventListener('izyrentChange', function () { setTimeout(sync, 50); });
    document.addEventListener('izyrentClose', function () { setTimeout(sync, 50); });
  }

  // IzyRent init est async (polling jusqu'à 15s dans izyrent-assurance.js).
  // On attend que #izyrent soit dans le DOM avant d'attacher l'observer.
  function waitForIzyrent() {
    var MAX_WAIT = 15000;
    var POLL = 300;
    var elapsed = 0;
    function tick() {
      if (document.getElementById('izyrent')) {
        init();
      } else if (elapsed < MAX_WAIT) {
        elapsed += POLL;
        setTimeout(tick, POLL);
      }
    }
    tick();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForIzyrent);
  } else {
    waitForIzyrent();
  }

  // Aussi sur bfcache restore (Safari surtout)
  window.addEventListener('pageshow', sync);
})();
